import { useHttpClient } from '@repo/api-client/react';
import {
  SubmitFeedbackResponseSchema,
  type SubmitFeedbackRequest,
  type SubmitFeedbackResponse,
} from '@repo/api-client/dtos';
import { useMutation } from '@tanstack/react-query';

import { postJSON } from '../internal/http';

/**
 * `POST /v1/feedback` — sends a user-submitted report to the server.
 *
 * The server side currently logs the payload and returns an ack; the
 * mailer wiring is tracked as a follow-up. The hook surface is stable
 * either way so screens don't need to change when we plug in a real
 * destination.
 */
export function useSubmitFeedback() {
  const http = useHttpClient();

  const mutation = useMutation({
    mutationFn: (body: SubmitFeedbackRequest) =>
      postJSON(http, '/feedback', body, SubmitFeedbackResponseSchema),
  });

  return {
    submitFeedback: mutation.mutateAsync as (
      body: SubmitFeedbackRequest,
    ) => Promise<SubmitFeedbackResponse>,
    loading: mutation.isPending,
    error: mutation.error,
  };
}
